var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSobreCelular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Circle_Button_SIZE_LARGE_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Circle Button [SIZE=LARGE][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(-0.289 -0.313)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_SIZE:LARGE_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [SIZE:LARGE][STATE:DEFAULT][STYLE:STYLE2]",
    width: 112,
    height: 112,
    rx: 56,
    transform: "translate(0.289 0.312)",
    fill: "#bbe56b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ICON_feather_heart_SIZE_LARGE_STATE_DEFAULT_STYLE_STYLE2_",
    "data-name": "Icon [ICON=feather/heart][SIZE=LARGE][STATE=DEFAULT][STYLE=STYLE2]",
    transform: "translate(26.845 25.406)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area_ICON:feather_heart_SIZE:LARGE_STATE:DEFAULT_STYLE:STYLE2_",
    "data-name": "Area [ICON:feather/heart][SIZE:LARGE][STATE:DEFAULT][STYLE:STYLE2]",
    width: 58,
    height: 58,
    transform: "translate(0.444 1.906)",
    fill: "#bbe56b",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(7.578 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "b9a01aa5-48bb-437d-aa62-6c2d2314045a",
    width: 40.877,
    height: 58.395,
    rx: 2,
    transform: "translate(1.732 1.732)",
    fill: "#bbe56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b9a01aa5-48bb-437d-aa62-6c2d2314045a_-_Contorno",
    "data-name": "b9a01aa5-48bb-437d-aa62-6c2d2314045a - Contorno",
    d: "M1.464-2H38.877a3.468,3.468,0,0,1,3.464,3.464V56.4a3.468,3.468,0,0,1-3.464,3.464H1.464A3.468,3.468,0,0,1-2,56.4V1.464A3.468,3.468,0,0,1,1.464-2ZM38.877,56.4V1.464H1.462l0,54.931Z",
    transform: "translate(2 2)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2f35f3d3-a429-4756-bd0b-1a9afb19f667",
    "data-name": "2f35f3d3-a429-4756-bd0b-1a9afb19f667",
    d: "M-.371,2.2A2.61,2.61,0,0,1-2.983-.4,2.586,2.586,0,0,1-.4-3h.029a2.6,2.6,0,0,1,2.6,2.6A2.6,2.6,0,0,1-.371,2.2Z",
    transform: "translate(22.57 48.85)",
    fill: "#2f2f2f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSobreCelular);
export default __webpack_public_path__ + "static/media/Sobre_Celular.2f678f417966b074188c9b08cc23145e.svg";
export { ForwardRef as ReactComponent };